/**
 * 员工建档请求共用入口。账号重复必须直接阻止；同名可能是不同的人，
 * 因此仅在用户核实后用原始表单重试，取消时返回 cancelled 供页面保留表单。
 * detailRaw 是全局错误拦截器保存的结构化详情；无详情时也能完成确认。
 */
export async function postEmployeeWithDuplicateCheck(api, url, payload, zh, method = "post") {
  try {
    return { response: await api[method](url, payload), cancelled: false };
  } catch (error) {
    const data = error?.response?.data;
    const detail = data?.detailRaw || data?.detail;
    if (error?.response?.status !== 409 || detail?.code !== "employee_duplicate_name") throw error;
    const matches = Array.isArray(detail.matches) ? detail.matches : [];
    const names = matches.map((m) => [m.name, m.nameZh, m.username, m.branch, m.department, m.status].filter(Boolean).join(" · ")).filter(Boolean);
    const message = zh ? (detail.message || "已存在同名员工档案。") : "An employee with the same name already exists or is pending creation.";
    const question = zh ? "请先在有权查看的员工档案范围内核实，确认是不同员工后再继续操作。确认继续吗？" : "Please check the employee records you can access. Continue only after confirming this is a different person. Continue?";
    if (!window.confirm([message, ...names, question].join("\n\n"))) return { cancelled: true };
    return { response: await api[method](url, { ...payload, allowDuplicateName: true }), cancelled: false };
  }
}
